import React from 'react';
import { Link } from 'react-router-dom';
import styles from './PrivacyPolicyPage.module.css';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className={styles.privacyPolicyPage}>
      <div className={styles.privacyPolicyContainer}>
        {/* Header */}
        <div className={styles.privacyPolicyHeader}>
          <div className={styles.privacyPolicyIcon}>
            <svg
              className="w-8 h-8 text-white flex-shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              style={{ maxWidth: '32px', maxHeight: '32px' }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
              />
            </svg>
          </div>
          <h1 className={styles.privacyPolicyTitle}>Privacy Policy</h1>
          <p className={styles.privacyPolicySubtitle}>
            We value your privacy and are committed to protecting your personal
            information.
          </p>
        </div>

        {/* Policy Content */}
        <div className={styles.privacyPolicyContent}>
          <div className={styles.privacyPolicySection}>
            <h2 className={styles.privacyPolicySectionTitle}>Privacy Policy</h2>

            <p className={styles.privacyPolicyText}>
              We value your privacy and the information you consent to share in
              relation to our SMS marketing service. We use this information to
              send you text notifications (for your order, including abandoned
              checkout reminders), text marketing offers, and transactional
              texts, including requests for reviews from us.
            </p>

            <div className={styles.privacyPolicyInfoBox}>
              <h3 className={styles.privacyPolicySectionTitle}>
                SMS Marketing & Data Protection
              </h3>
              <p className={styles.privacyPolicyInfoText}>
                Opt-in data and consent for text messaging will not be shared
                with any third parties except for messaging partners, for the
                purpose of enabling and operating our text messaging program.
              </p>
            </div>

            <h3 className={styles.privacyPolicySectionTitle}>Cookie Usage</h3>
            <p className={styles.privacyPolicyText}>
              Our website uses cookies to keep track of items you put into your
              shopping cart, including when you have abandoned your checkout.
              This information is used to determine when to send cart reminder
              messages via SMS.
            </p>

            <h3 className={styles.privacyPolicySectionTitle}>
              Additional Agreements
            </h3>
            <p className={styles.privacyPolicyText}>
              In addition, you agree to our Messaging Terms and the following
              Messaging Service Privacy Policy:
            </p>

            {/* Project michael Messaging Service Privacy Policy */}
            <div className={styles.privacyPolicyInfoBox}>
              <h4 className={styles.privacyPolicySectionTitle}>
                Project Michael Messaging Service Privacy Policy
              </h4>
              <p className={styles.privacyPolicyInfoText}>
                This Messaging Service Privacy Policy explains how Project
                Michael (hereinafter, &quot;Project Mutlander,&quot;
                &quot;We,&quot; &quot;Us,&quot; &quot;Our&quot;) collects, uses,
                and shares personal information about you in relation to Our
                text message marketing program (the &quot;Messaging
                Service&quot;). This Messaging Service Privacy Policy
                supplements Our Primary Privacy Policy. For more details, see
                the section titled &quot;Primary Privacy Policy&quot; below.
              </p>

              <h5 className={styles.privacyPolicySectionTitle}>
                Changes to the Messaging Service Privacy Policy
              </h5>
              <p className={styles.privacyPolicyInfoText}>
                We may revise this Messaging Service Privacy Policy from time to
                time in our sole discretion. If there are any material changes
                to this Messaging Service Privacy Policy, we will notify you as
                required by applicable law. You understand and agree that you
                will be deemed to have accepted the updated Messaging Service
                Privacy Policy if you continue to use the Messaging Service
                after the new Messaging Service Privacy Policy takes effect.
              </p>

              <h5 className={styles.privacyPolicySectionTitle}>
                Personal Information We Collect
              </h5>
              <p className={styles.privacyPolicyInfoText}>
                When you sign up for the Messaging Service, We collect personal
                information such as your name, phone number, and email address.
                When you use the Messaging Service to send or receive messages,
                We collect communications metadata (e.g., the time/date a
                message was sent or received) and the contents of any
                communications you send or receive via the Messaging Service.
              </p>
              <p className={styles.privacyPolicyInfoText}>
                We may also collect information about you using cookies or
                similar technologies on Our website or other digital properties.
                Cookies are small text files placed on device browsers that
                store preferences and facilitate and enhance your experience.
                Cookies enable personalization of your experience via the
                Messaging Service (e.g., sending you personalized text messages
                such as shopping cart reminders).
              </p>
              <p className={styles.privacyPolicyInfoText}>
                If you participate in a contest, sweepstakes, research study, or
                email survey associated with the Messaging Service, We will
                collect basic contact information and any other information you
                choose to provide in connection with these activities. We will
                also collect your personal information if you contact Us with
                questions about the Messaging Service or for customer service.
              </p>

              <h5 className={styles.privacyPolicySectionTitle}>
                Use of Personal Information
              </h5>
              <p className={styles.privacyPolicyInfoText}>
                We use your information to deliver, analyze, maintain and
                support the Messaging Service. We may also use your information
                to enhance the Messaging Service features and customize and
                personalize your experiences on the Messaging Service; to
                identify and prevent security risks; to prevent fraudulent,
                deceptive, and malicious activity including harassment and
                identify theft; and to verify and maintain the safety, quality,
                and accuracy of the Messaging Service. For example, We may use
                cookies to prefill your contact information, and to verify that
                you are authorized to consent to receive marketing messages to
                your device.
              </p>
              <p className={styles.privacyPolicyInfoText}>
                We may use your personal information to generate aggregated
                and/or de-identified information. Aggregated and/or
                de-identified information is not personal information and may be
                shared with any third party, including advertisers, promotional
                partners, and sponsors.
              </p>

              <h5 className={styles.privacyPolicySectionTitle}>
                Sharing of Personal Information
              </h5>
              <p className={styles.privacyPolicyInfoText}>
                We may share your personal information as contemplated in Our
                primary privacy policy, if you consent to Us doing so, as well
                as in the following circumstances:
              </p>
              <ul className={styles.privacyPolicyList}>
                <li>
                  <strong>
                    Third Parties that Help Provide the Messaging Service.
                  </strong>{' '}
                  We may share your personal information with third parties that
                  help Us provide the Messaging Service (including, but not
                  limited to, platform providers, phone companies, and other
                  vendors who assist us in the delivery of text messages, fraud
                  prevention, maintaining the security of the Messaging Service,
                  and to verify your device and contact information).
                </li>
                <li>
                  <strong>
                    Legal Requirements, Disclosures to Protect Us or Others.
                  </strong>{' '}
                  We may disclose any information We store associated with you
                  to external parties if We, in good faith, believe doing so is
                  required or appropriate to: comply with law enforcement or
                  national security requests and legal process, such as a court
                  order or subpoena; protect your, Our, or others&apos; rights,
                  property, or safety; Our policies or contracts; collect
                  amounts owed to Us; or assist with an investigation or
                  prosecution of suspected or actual illegal activity.
                </li>
              </ul>

              <h5 className={styles.privacyPolicySectionTitle}>
                Accurate Information
              </h5>
              <p className={styles.privacyPolicyInfoText}>
                When you complete forms online or otherwise provide Us
                information in connection with the Messaging Service, you agree
                to provide accurate, complete, and true information. You agree
                not to use a false or misleading name or a name that you are not
                authorized to use. If, in Our sole discretion, We believe that
                any such information is untrue, inaccurate, or incomplete, or
                you have opted into the Messaging Service for an ulterior
                purpose, We may refuse you access to the Messaging Service and
                pursue any appropriate legal remedies.
              </p>

              <h5 className={styles.privacyPolicySectionTitle}>
                Choices and Controls
              </h5>
              <p className={styles.privacyPolicyInfoText}>
                Text messages may be sent via an automatic telephone dialing
                system. Consent to receive automated marketing text messages is
                not a condition of any purchase. You can opt-out of receiving
                further commercial text messages via the Messaging Service by
                responding to any of Our text messages with any of the following
                replies: STOP, END, CANCEL, UNSUBSCRIBE, or QUIT. For additional
                opt-out information, please review Our Terms of Service.
              </p>

              <h5 className={styles.privacyPolicySectionTitle}>
                Customer Care
              </h5>
              <p className={styles.privacyPolicyInfoText}>
                If you are experiencing any problems with the Messaging Service,
                please visit{' '}
                <a
                  href="https://michael.tybierwagen.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  https://michael.tybierwagen.com
                </a>{' '}
                and submit the form with details about your problem or your
                request for support, or email{' '}
                <a
                  href="mailto:tybierwagen@gmail.com"
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  tybierwagen@gmail.com
                </a>
                .
              </p>

              <h5 className={styles.privacyPolicySectionTitle}>
                Supplemental California Privacy Notice
              </h5>
              <p className={styles.privacyPolicyInfoText}>
                This Supplemental California Privacy Notice only applies to Our
                processing of personal information via the Messaging Service
                that is subject to the California Consumer Privacy Act of 2018
                (&quot;CCPA&quot;). The CCPA provides California residents with
                the right to know what categories of personal information We
                have collected about them and whether We have disclosed that
                personal information for a business purpose (e.g., to a service
                provider) in the preceding twelve months. California residents
                can find this information below:
              </p>

              <div className="overflow-x-auto mb-4">
                <table className="min-w-full border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-4 py-2 text-left font-semibold">
                        Category of Personal Information Collected by Us
                      </th>
                      <th className="border border-gray-300 px-4 py-2 text-left font-semibold">
                        Categories of Third Parties Personal Information is
                        Disclosed to for a Business Purpose
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">
                        Identifiers
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        • Service providers
                      </td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-4 py-2">
                        Personal information categories listed in Cal. Civ. Code
                        § 1798.80(e)
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        • Service providers
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">
                        Commercial information
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        • Service providers
                      </td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-4 py-2">
                        Internet or other electronic network activity
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        • Service providers
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">
                        Inferences drawn from other personal information to
                        create a profile about a consumer
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        • Service providers
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className={styles.privacyPolicyInfoText}>
                The categories of sources from which We collect personal
                information and Our business and commercial purposes for using
                personal information are set forth above and in Our primary
                privacy policy.
              </p>

              <h5 className={styles.privacyPolicySectionTitle}>
                Additional Privacy Rights for California Residents
              </h5>
              <p className={styles.privacyPolicyInfoText}>
                <strong>Individual Rights under the CCPA.</strong>
                <br />
                The CCPA provides California residents with the right to
                request:
              </p>
              <ul className={styles.privacyPolicyList}>
                <li>
                  Access to Personal Information, including obtaining access to
                  or a copy of your personal information.
                </li>
                <li>Deletion of Personal Information</li>
              </ul>
              <p className={styles.privacyPolicyInfoText}>
                If you are a California resident and would like to exercise any
                of your rights under the CCPA, please contact Us at{' '}
                <a
                  href="mailto:tybierwagen@gmail.com"
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  tybierwagen@gmail.com
                </a>
                . We will process such requests in accordance with applicable
                laws.
              </p>

              <p className={styles.privacyPolicyInfoText}>
                <strong>
                  &quot;Sales&quot; of Personal Information under the CCPA.
                </strong>{' '}
                For purposes of the CCPA, unless otherwise stated in Our primary
                privacy policy, We do not &quot;sell&quot; personal information,
                nor do we have actual knowledge of any &quot;sale&quot; of
                personal information of minors under 16 years of age.
              </p>

              <p className={styles.privacyPolicyInfoText}>
                <strong>Non-Discrimination.</strong> California residents have
                the right not to receive discriminatory treatment by Us for the
                exercise of their rights conferred by the CCPA.
              </p>

              <p className={styles.privacyPolicyInfoText}>
                <strong>Authorized Agent.</strong> Only you, or someone legally
                authorized to act on your behalf, may make a verifiable consumer
                request related to your personal information. To designate an
                authorized agent, please contact Us at{' '}
                <a
                  href="mailto:tybierwagen@gmail.com"
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  tybierwagen@gmail.com
                </a>
                .
              </p>

              <p className={styles.privacyPolicyInfoText}>
                <strong>Verification.</strong> When you make a request, We will
                ask you to provide sufficient information that allows Us to
                reasonably verify you are the person about whom we collected
                personal information or an authorized representative, which may
                include confirming the email address or phone number associated
                with any personal information We have about you.
              </p>

              <h5 className={styles.privacyPolicySectionTitle}>
                Primary Privacy Policy
              </h5>
              <p className={styles.privacyPolicyInfoText}>
                By signing up to receive text messages from us, you also agree
                to Our Primary Privacy Policy. This Messaging Service Privacy
                Policy is strictly limited to the Messaging Service and does not
                limit or restrict any other privacy policy(ies) that may govern
                the relationship between you and Us in other contexts.
              </p>
            </div>

            <div className={styles.privacyPolicyListBox}>
              <h4 className={styles.privacyPolicySectionTitle}>
                What We Collect
              </h4>
              <ul className={styles.privacyPolicyList}>
                <li>SMS opt-in data and consent</li>
                <li>Shopping cart information</li>
                <li>Checkout abandonment data</li>
                <li>Order notifications</li>
                <li>Marketing preferences</li>
              </ul>
            </div>

            <div className={styles.privacyPolicyInfoBox}>
              <h4 className={styles.privacyPolicySectionTitle}>
                How We Use Your Information
              </h4>
              <ul className={styles.privacyPolicyList}>
                <li>Send order notifications and updates</li>
                <li>Remind you about abandoned shopping carts</li>
                <li>Provide customer support</li>
                <li>Send marketing offers (with your consent)</li>
                <li>Request product reviews</li>
              </ul>
            </div>

            <div className={styles.privacyPolicyListBox}>
              <h4 className={styles.privacyPolicySectionTitle}>
                Data Protection
              </h4>
              <ul className={styles.privacyPolicyList}>
                <li>We do not sell your personal information</li>
                <li>
                  Data is only shared with messaging partners for service
                  operation
                </li>
                <li>Your consent can be withdrawn at any time</li>
                <li>We use industry-standard security measures</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Back to Shopping */}
        <div className={styles.privacyPolicyBackButton}>
          <Link to="/" className={styles.backToShoppingButton}>
            <svg
              className={styles.backToShoppingIcon}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            <span>Back to Shopping</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
